module.exports = __webpack_public_path__ + "img/circle.be5030ca.webp";